import React from 'react';
import { Link } from 'react-router-dom';
import GeometricBackground from '@/components/GeometricBackground';
import { LEGAL_ENTITY, POLICY_LAST_UPDATED } from '@/constants/legalEntity';
import LegalLinks from '@/components/legal/LegalLinks';

interface LegalPolicyLayoutProps {
  title: string;
  children: React.ReactNode;
}

const LegalPolicyLayout: React.FC<LegalPolicyLayoutProps> = ({ title, children }) => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <GeometricBackground />
      <div className="relative z-10 py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm text-slate-500 mb-2">
            <Link to="/" className="text-violet-700 hover:underline">
              {LEGAL_ENTITY.productName}
            </Link>
            {' · Legal'}
          </p>
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">{title}</h1>
          <p className="text-sm text-slate-500 mb-6">
            Operated by {LEGAL_ENTITY.legalNameEn} ({LEGAL_ENTITY.legalNameMk}),{' '}
            {LEGAL_ENTITY.country}. Last updated: {POLICY_LAST_UPDATED}.
          </p>

          <div className="bg-white/90 backdrop-blur-md rounded-2xl border border-slate-200/90 shadow-lg p-6 md:p-8 text-sm md:text-base text-slate-700 legal-prose">
            {children}
          </div>

          <div className="mt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <LegalLinks className="text-sm" />
            <p className="text-xs text-slate-500">
              Questions:{' '}
              <a href={`mailto:${LEGAL_ENTITY.contactEmail}`} className="text-violet-700 hover:underline">
                {LEGAL_ENTITY.contactEmail}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPolicyLayout;
